<div>
  <div class="bg" (click)="close()"></div>
  <div class="window block border">
    <ng-content></ng-content>
  </div>
</div>
